import {
  EstadosLlamadaEnumChoice,
  EstadosPreagendamientoEnumChoice,
  ROUTER_PATHS,
} from "@/shared";
import {
  CustomButtunsRejectConfirm,
  SingleFormBoxScene,
} from "@/shared/components/ui";
import {
  AlertSeverityEnum,
  ErrorMessagesForm,
  EstadoBitacoraEnum,
  TipoSolicitudesEnum,
} from "@/shared/interfaces";
import {
  cellLineaRazonSocial,
  handleErrorForm,
} from "@/shared/utils";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { SaveFormDataPreagendamiento } from "@/erp/operaciones/preagendamiento/shared/interface/SaveFormDataPreagendamiento";
import useBackDetection from "@/erp/operaciones/preagendamiento/shared/hooks/useBackDetection";
import { RejectPreagendaModal } from "@/erp/operaciones/preagendamiento/shared/components";
import PreagendamientoSingleSoportePymes from "./PreagendamientoSingleSoportePymes";
import { preagendamientoPymesFormSchema } from "@/shared/utils/validation-schemas/erp/operaciones/preagendamiento/preagendamientoPymes.schema";
import { IPreagendamientoPymes } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useFetchPutPreagendamientoPymes } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";
import { Typography } from "@mui/material";
import TipoVentaCanjeEvento from "@/shared/components/ui/TipoVentaCanjeEvento/TipoVentaCanjeEvento";


function getEstadoPreAgendamiento({ solicitar_tecnico, isRejecting, estado_llamada, estado_preagendamiento }: {
  solicitar_tecnico: boolean,
  isRejecting: boolean,
  estado_llamada: string
  estado_preagendamiento: string
}
): EstadosPreagendamientoEnumChoice {

  if (solicitar_tecnico) {
    return estado_preagendamiento as EstadosPreagendamientoEnumChoice
  }

  if (isRejecting) {
    return EstadosPreagendamientoEnumChoice.PRERECHAZADO;
  }

  if (estado_llamada === EstadosLlamadaEnumChoice.NO_CONTESTA ||
    estado_llamada === EstadosLlamadaEnumChoice.MENSAJE_WHATSSAPP) {
    return EstadosPreagendamientoEnumChoice.EN_PAUSA;
  }

  if (estado_preagendamiento === EstadosPreagendamientoEnumChoice.FINALIZADO) {
    return EstadosPreagendamientoEnumChoice.RECORDINADO
  }

  return EstadosPreagendamientoEnumChoice.FINALIZADO;
}

export interface SavePreagendamientoSoportePymesProps {
  title: string;
  preagendamiento?: IPreagendamientoPymes;
}


const SavePreagendamientoSoportePymes: React.FC<SavePreagendamientoSoportePymesProps> = ({
  title,
  preagendamiento,
}) => {
  const navigate = useNavigate();
  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.soportePymes.preagendamientoNav;

  const plans = usePlanStore(s => s.plans);
  ///* local state --------------------
  const [openRechazoModal, setOpenRechazoModal] = useState(false);
  const [shrink] = useState(true);

  ///* global state --------------------
  const setAlert = useUiStore((s) => s.setAlert);

  //const { isLoadingFlotas, getFlotaAdicional } = useFlotasStore();

  const emitFinalizarVenta = useDiccionarioMotivo((s) => s.emitFinalizarVenta);


  ///* form --------------------
  const form = useForm<SaveFormDataPreagendamiento>({
    resolver: yupResolver(preagendamientoPymesFormSchema) as any,
    defaultValues: {
      estado: true,
      isRejecting: false,
      solicitar_tecnico: false,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = form;

  ///* mutations --------------------
  const updatePreagendamientoMutation =
    useFetchPutPreagendamientoPymes({});

  const updatePreAgendamientoMutationOcupado =
    useFetchPutPreagendamientoPymes({});

  ///* handlers --------------------

  const onSave = async (data: SaveFormDataPreagendamiento) => {

    if (!isValid) return;

    const dataForm = {
      celular: data.celular!,
      representante_celular1: data.representante_celular1!,
      email: data.email!,
      direccion: data.direccion!,
      //coordenadas: data.coordenadas!,
      coordenadas: preagendamiento?.preventa_pymes_data.coordenadas,
      es_pyme: true,
      // estado llamada ----
      estado_llamada: data.estado_llamada!,
      fecha_hora_llamada: dayjs().format(),
      nap: data.nap,
      distancia: data.distancia,
      observaciones: {
        ...preagendamiento?.preventa_pymes_data?.observaciones,
        observacion_llamada: data.observacion_llamada!,
        observacion_rechazo: data.observacion_rechazo || "",
        observacion_tecnico_adicional: data.observacion_tecnico_adicional || "",
      },
      pais: data.pais!,
      ciudad: data.ciudad!,
      provincia: data.provincia!,
      zona: data.zona!,
      //sector: data.sector!,
      estado_preagendamiento: getEstadoPreAgendamiento({
        solicitar_tecnico: data.solicitar_tecnico ?? false,
        estado_llamada: data.estado_llamada,
        isRejecting: data.isRejecting!,
        estado_preagendamiento: preagendamiento?.estado_preagendamiento!
      }),

      motivo_rechazo: data.motivo_rechazo || null,
      user_gestionando: null,
      solicitar_tecnico: data.solicitar_tecnico,
      flota: data.flota,
      nombre_enlace: data.nombre_enlace,
      ///* Cambio de flota y hora de instalacion
      hora_instalacion: data.hora_instalacion!,
      fecha_instalacion: data.fecha_instalacion,
      fecha_tecnico_adicional: data.fecha_tecnico_adicional,
      hora_tecnico_adicional: data.hora_tecnico_adicional,
      fecha_instalacion_original: preagendamiento?.fecha_instalacion!,
      hora_instalacion_original: preagendamiento?.hora_instalacion!,
      flota_adicional: null
    };

    ///* upd
    if (preagendamiento && preagendamiento?.id_preagendamiento_pymes) {

      const resp = await updatePreagendamientoMutation.mutateAsync({
        id: preagendamiento.id_preagendamiento_pymes!,
        data: dataForm as any,
      });

      if (resp.code === 200) {
        navigate(returnUrlAgendamientosPyLPage);
      }

      ///* Envío de PyL a Gestión Ventas desde cualquier estado se cierra bitacora automaitco

      if (
        form.getValues().estado_llamada == EstadosLlamadaEnumChoice.REALIZADA ||
        openRechazoModal
      )
        emitFinalizarVenta({
          numero_referencia_venta: preagendamiento?.id_preagendamiento_pymes,
          estado_venta: EstadoBitacoraEnum.FINALIZADO,
        });

      return;
    }
  };

  const onCancel = async (preagendamiento: IPreagendamientoPymes) => {
    updatePreAgendamientoMutationOcupado.mutate({
      id: preagendamiento?.id_preagendamiento_pymes!,
      data: {
        user_gestionando: null,
      },
    });

    navigate(returnUrlAgendamientosPyLPage);
  };

  const releasePreagendamiento = async () => {
    updatePreAgendamientoMutationOcupado.mutate({
      id: preagendamiento?.id_preagendamiento_pymes!,
      data: {
        user_gestionando: null,
      },
    });
  };

  ///* effects --------------------
  useBackDetection(releasePreagendamiento, preagendamiento!);

  useEffect(() => {
    if (!preagendamiento?.id_preagendamiento_pymes) return;

    const {
      preventa_pymes_data,
      prospecto_pymes_data,
      flota_data,
      flota_adicional_data,
      flota_adicional,
      ...rest
    } = preagendamiento;

    if (flota_adicional) {
      console.log('consultar flota adicional');
    }



    delete preventa_pymes_data.flota;
    const dataEnlace = preagendamiento.preventa_pymes_data.coordenadas.find(e => e.codigo == rest.codigo);
    const dataPlanEnlace = plans.find(e => e.codigo == dataEnlace?.plan);

    console.log(dataEnlace);
    
    reset({
      ...prospecto_pymes_data,
      ...preventa_pymes_data,
      ...rest,
      observacion_1: preventa_pymes_data?.observaciones.observacion_1 || "",
      observacion_2: preventa_pymes_data?.observaciones.observacion_2 || "",
      es_referido: !!preventa_pymes_data?.tipo_referido ? "SI" : "NO",
      isRejecting: false,
      flota: flota_adicional ?? flota_data?.codigo ?? "",
      rawNap: rest.nap_data || {},
      observacion_llamada:
        preagendamiento.observaciones?.observacion_llamada || "",
      observacion_rechazo:
        preagendamiento.observaciones?.observacion_rechazo || "",
      coordenadas: dataEnlace?.coordenada,
      nombre_enlace: dataEnlace?.nombre,
      direccion: dataEnlace?.direccion,
      planLabel: dataPlanEnlace?.nombre,
      tipo_servicio: dataPlanEnlace?.tipo_servicio,
      velocidad_internet: dataPlanEnlace?.velocidad_subida_maxima,
      valor_instalacion: dataEnlace?.valor_instalacion,
      valor_instalacion_iva: dataEnlace?.valor_instalacion_total,
    } as any);

  }, [preagendamiento]);

  //if (isLoadingFlotas) return <LoaderComponent />

  return (
    <>
      <SingleFormBoxScene
        titlePage={title}
        showCustomBtns={true}
        showActionBtns={false}
        num_referencia={cellLineaRazonSocial(null, preagendamiento?.prospecto_pymes_data?.razon_social!, preagendamiento?.contrato_data.linea)}
        customBtns={
          <CustomButtunsRejectConfirm
            onCancel={() => onCancel(preagendamiento!)}
            onConfirm={() => {
              handleSubmit(onSave, (err) => {
                if (err?.estado_llamada || err?.observacion_llamada)
                  return setAlert(
                    true,
                    "El estado de llamada y su observación son requeridos",
                    AlertSeverityEnum.error
                  );
                handleErrorForm(err as ErrorMessagesForm);
              })();
            }}
            rejectTextBtn="Enviar a Gestión Ventas"
            showRejectBtn={true}
            onReject={() => {
              setOpenRechazoModal(true);
              form.reset({
                ...form.getValues(),
                isRejecting: true,
              });
            }}
            sxContainer={{
              pt: 5,
            }}
          />

        }
        additionalNoteText={
          <>
            <TipoVentaCanjeEvento
              tipo_venta={TipoSolicitudesEnum.PYMES}
              prospecto_data={preagendamiento?.prospecto_pymes_data as any}
            />

            <Typography>Punto de Enlace: <b>{
              preagendamiento?.nombre_enlace
            }</b></Typography>
          </>
        }
      >
        <PreagendamientoSingleSoportePymes
          form={form}
          shrink={shrink}
          preagendamiento={preagendamiento!}
        />
      </SingleFormBoxScene>

      <RejectPreagendaModal
        open={openRechazoModal}
        onClose={() => {
          form.reset({
            ...form.getValues(),
            isRejecting: false,
          });
          setOpenRechazoModal(false);
        }}
        //preagendamiento={preagendamiento!}
        form={form}
        onConfirm={() => {
          handleSubmit(onSave, (err) => {
            if (err?.estado_llamada || err?.observacion_llamada)
              return setAlert(
                true,
                "El estado de llamada y su observación son requeridos",
                AlertSeverityEnum.error
              );
            handleErrorForm(err as ErrorMessagesForm);
          })();
        }}
      />

    </>
  )

};

export default SavePreagendamientoSoportePymes;
